var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFrutiger55Roman = function SvgFrutiger55Roman(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("version", null, "1.0"), /*#__PURE__*/React.createElement("id", null), /*#__PURE__*/React.createElement("vendor", null, "Monotype Imaging Inc."), /*#__PURE__*/React.createElement("credits", null, /*#__PURE__*/React.createElement("name", null, "Fonts.com WebFonts"), /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com"), /*#__PURE__*/React.createElement("role", null, "Home of the Web fonts")), /*#__PURE__*/React.createElement("license", null, /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com/Legal")), /*#__PURE__*/React.createElement("copyright", null), /*#__PURE__*/React.createElement("trademark", null), /*#__PURE__*/React.createElement("licensee", null, /*#__PURE__*/React.createElement("name", null)))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    horizAdvX: 538,
    id: "FrutigerLTW01-55Roman"
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "",
    panose1: "2 11 5 3 3 5 4 2 2 4",
    ascent: 935,
    descent: -250,
    unitsPerEm: 1000,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\n"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 389,
    d: "M139 112H251V0H139V112ZM238 196H152L139 698H251L238 196Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 556,
    d: "M159 698H247V453H159V698ZM309 698H397V453H309V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 556,
    d: "M346 414H228L210 284H328L346 414ZM123 208H28V284H134L152 414H56V490H163L192 698H268L239 490H357L386 698H462L433 490H528V414H422L404 284H499V208H393L364 0H288L317 208H199L170 0H94L123 208Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 556,
    d: "M247 -12H235Q191 -12 155 -5T83 17L95 113Q123 93 156 85T233 76H247V319L213 336Q184 351 159 368T115 406T86 456T75 520Q75 558 88 589T125 645T179 684T247 706V806H305V710Q381 708 448 685L434 593Q385 622 315 622H305V405L363 373Q391 358 413 341T450 303T473 256T481 195Q481 154 469 120T433 60T378 17T305 -6V-106H247V-12ZM305 87Q337 97 356 126T375 189Q375 230 355 252T305 290V87ZM247 614Q215 602 198 582T181 523Q181 491 202 471T247 435V614Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1000,
    d: "M260 380Q282 380 294 394T313 429T320 472T322 510Q322 527 322 549T316 592T298 626T260 640Q237 640 225 626T206 591T199 548T198 510Q198 495 199 473T206 430T224 395T260 380ZM740 -12Q697 -12 668 5T622 50T598 114T590 188Q590 228 596 264T619 328T665 372T740 388Q785 388 814 372T860 328T883 264T890 188Q890 150 883 114T858 50T812 5T740 -12ZM680 720H752L319 -22H247L680 720ZM740 58Q762 58 774 72T793 107T800 150T802 188Q802 205 802 227T796 270T778 304T740 318Q717 318 705 304T686 269T679 226T678 188Q678 173 679 151T686 108T704 73T740 58ZM260 310Q217 310 188 327T142 372T118 436T110 510Q110 550 116 586T139 650T185 694T260 710Q305 710 334 694T380 650T403 586T410 510Q410 472 403 436T378 372T332 327T260 310Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 722,
    d: "M261 544Q261 509 280 480T323 426Q339 433 357 445T391 472T417 507T428 548Q428 596 405 615T345 634Q310 634 286 612T261 544ZM189 190Q189 161 200 138T230 99T274 73T326 64Q350 64 370 71T407 88T435 110T455 131L287 328Q267 314 250 301T219 271T197 236T189 190ZM648 377Q645 335 638 301T620 238T596 185T568 138L690 0H565L508 68Q470 25 423 7T308 -12Q256 -12 215 2T144 41T99 103T83 183Q83 262 125 310T239 387Q211 421 189 458T167 546Q167 588 181 619T220 670T278 700T349 710Q383 710 414 701T470 673T508 623T522 552Q522 519 509 491T473 440T424 400T369 370L511 208Q531 240 540 278T554 377H648Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 278,
    d: "M95 698H183V453H95V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 333,
    d: "M229 -140Q195 -89 165 -37T113 71T78 186T65 308Q65 372 78 430T113 544T165 651T229 756H319Q290 705 263 651T213 541T178 427T165 308Q165 248 178 190T212 75T261 -35T319 -140H229Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 333,
    d: "M104 756Q138 705 168 652T220 544T255 430T268 308Q268 244 255 186T220 72T168 -35T104 -140H14Q43 -89 70 -35T120 75T155 189T168 308Q168 368 155 426T121 541T72 651T14 756H104Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 556,
    d: "M278 448L196 310L122 360L232 483L72 516L100 601L251 539L235 698H326L311 539L457 601L484 516L327 483L434 360L359 310L278 448Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 600,
    d: "M47 297H256V506H344V297H553V209H344V0H256V209H47V297Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 278,
    d: "M83 112H195L110 -133H20L83 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 333,
    d: "M38 307H295V231H38V307Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 278,
    d: "M83 112H195V0H83V112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 278,
    d: "M215 710H303L63 -12H-25L215 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 556,
    d: "M147 349Q147 327 148 298T154 238T167 177T190 123T226 85T278 70Q308 70 329 84T365 123T388 177T401 238T407 298T409 349Q409 382 405 429T387 521T347 597T278 628Q235 628 209 597T170 522T152 430T147 349ZM41 349Q41 406 51 470T87 587T159 675T278 710Q350 710 396 675T469 587T505 470T515 349Q515 292 505 228T469 111T397 23T278 -12Q206 -12 160 23T87 111T51 228T41 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 556,
    d: "M269 583L162 491L109 558L280 698H369V0H269V583Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 556,
    d: "M50 107Q77 131 109 159T175 219Q204 246 239 280T304 352T355 433T376 517Q376 541 366 561T337 597T295 620T242 628Q195 628 153 614T82 583L72 669Q116 688 161 699T255 710Q302 710 343 698T415 660T464 598T482 511Q482 467 462 423T410 338T344 260T280 194T217 135T157 82H492V0H50V107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 556,
    d: "M145 404H201Q228 404 258 409T314 428T357 463T374 518Q374 548 363 569T333 603T289 622T237 628Q189 628 152 617T82 590L76 679Q111 692 158 701T251 710Q297 710 338 699T411 665T461 605T480 520Q480 487 468 460T435 413T387 380T330 361V359Q400 345 443 303T486 186Q486 126 463 88T401 27T313 -3T211 -12Q169 -12 127 -4T51 15L57 108Q84 94 124 82T210 70Q238 70 268 76T323 96T364 133T380 189Q380 228 366 253T327 294T272 316T206 322H145V404Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 556,
    d: "M344 159H19V241L301 698H444V241H532V159H444V0H344V159ZM344 616H342L124 241H344V616Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 556,
    d: "M478 616H188L182 429Q196 433 219 436T272 439Q318 439 359 423T431 378T480 309T498 223Q498 166 477 122T419 48T334 3T231 -12Q174 -12 137 -4T81 11L84 105Q116 87 149 79T229 70Q260 70 289 79T341 105T378 149T392 208Q392 245 379 273T343 320T289 348T223 357Q178 357 147 350T88 331L94 698H478V616Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 556,
    d: "M405 217Q405 241 398 266T377 311T340 344T288 357Q257 357 233 346T192 316T167 272T158 217Q158 192 165 166T188 119T227 84T281 70Q312 70 335 82T374 115T397 162T405 217ZM465 599Q410 628 341 628Q292 628 256 607T196 551T159 470T146 374L148 375Q183 410 220 424T301 439Q352 439 391 422T456 376T497 306T511 219Q511 165 494 122T447 50T376 4T287 -12Q214 -12 168 18T97 96T62 203T52 323Q52 394 65 463T110 587T197 676T335 710Q353 710 374 708T415 703T453 696T479 688L465 599Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 556,
    d: "M491 616L233 0H123L389 616H49V698H491V616Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 556,
    d: "M155 529Q155 493 191 465T299 402Q330 426 348 443T375 476T388 507T391 540Q391 565 380 581T351 608T313 623T273 628Q256 628 236 622T197 604T167 573T155 529ZM412 180Q413 217 400 240T365 278T316 305T260 330Q239 315 218 303T181 275T154 240T144 189Q144 160 156 138T188 101T233 78T285 70Q336 70 373 98T412 180ZM276 -12Q232 -12 189 0T113 37T59 98T38 183Q38 253 80 299T186 367V369Q148 382 123 402T82 445T61 493T55 543Q55 576 70 606T115 660T186 696T281 710Q333 710 373 697T440 661T482 610T497 553Q497 524 491 499T469 453T430 412T371 373Q434 351 476 305T518 188Q518 135 499 98T446 36T369 0T276 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 556,
    d: "M151 481Q151 457 158 432T179 387T216 354T268 341Q299 341 323 352T364 382T389 426T398 481Q398 506 391 532T368 579T329 614T275 628Q243 628 220 616T182 583T159 536T151 481ZM91 99Q146 70 215 70Q264 70 300 91T360 147T397 228T410 324L408 323Q373 288 336 274T255 259Q204 259 165 276T100 322T59 392T45 479Q45 533 62 576T109 648T180 694T269 710Q342 710 388 680T459 602T494 495T504 375Q504 304 491 235T446 111T359 22T221 -12Q203 -12 182 -10T141 -5T103 2T77 10L91 99Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 278,
    d: "M83 112H195V0H83V112ZM195 398H83V510H195V398Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 278,
    d: "M195 398H83V510H195V398ZM83 112H195L110 -133H20L83 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 600,
    d: "M554 426L160 253L554 80V-8L46 215V291L554 514V426Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 600,
    d: "M47 192H553V104H47V192ZM47 402H553V314H47V402Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 600,
    d: "M46 80L440 253L46 426V514L554 291V215L46 -8V80Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 500,
    d: "M195 112H307V0H195V112ZM204 217Q204 241 207 259T217 295T236 328T266 366Q279 382 294 399T321 435T342 475T350 521Q350 547 340 566T313 597T275 616T229 622Q179 622 143 611T81 582L74 677Q107 691 148 700T240 710Q281 710 320 699T389 664T437 607T456 528Q456 489 442 458T408 399T363 344T319 287Q307 269 303 252T298 214V196H204V217Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 800,
    d: "M548 278Q545 267 543 256T540 236Q541 225 544 218T558 211Q580 211 601 226T640 266T669 326T680 398Q680 456 659 501T602 577T518 624T415 640Q352 640 300 618T210 555T153 462T132 347Q132 276 154 222T215 132T308 77T425 58Q488 58 545 81T642 147H718Q669 72 591 30T421 -12Q344 -12 276 12T158 82T79 196T50 349Q50 431 79 497T158 611T274 684T416 710Q482 710 542 689T649 628T722 534T750 413Q750 342 724 290T660 203T582 152T513 135Q490 135 474 149T455 191H453Q433 170 404 153T344 135Q313 135 286 148T239 182T208 233T196 295Q196 342 211 387T255 467T322 524T411 546Q446 546 474 531T525 480L540 532H615L548 278ZM366 217Q394 217 417 232T458 272T484 325T494 380Q494 416 472 440T417 464Q387 464 363 450T321 412T294 362T284 308Q284 268 306 243T366 217Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 611,
    d: "M183 400H238Q274 400 306 403T363 417T402 451T417 512Q417 543 405 563T374 595T333 611T288 616H183V400ZM183 82H258Q292 82 323 86T377 103T415 138T429 195Q429 235 413 259T371 297T313 314T248 318H183V82ZM83 698H272Q326 698 371 689T449 658T499 604T517 522Q517 450 478 412T373 356V354Q409 351 438 338T489 304T523 253T535 186Q535 130 514 94T456 37T371 8T269 0H83V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 611,
    d: "M571 583Q505 622 427 622Q367 622 318 602T233 545T178 458T159 349Q159 287 179 237T236 151T320 96T422 76Q441 76 462 78T503 85T542 96T574 110L580 13Q540 -4 496 -8T421 -12Q338 -12 270 13T154 86T80 201T53 352Q53 433 80 499T157 612T274 684T422 710Q463 710 502 704T579 680L571 583Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 722,
    d: "M183 88H288Q417 88 486 152T555 351Q555 412 536 460T482 541T401 592T300 610H183V88ZM83 698H289Q367 698 434 675T552 607T632 500T661 355Q661 267 635 201T561 90T444 23T289 0H83V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 556,
    d: "M94 698H485V610H194V406H459V318H194V88H485V0H94V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 500,
    d: "M83 698H454V610H183V406H442V318H183V0H83V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 722,
    d: "M619 574Q582 598 539 610T427 622Q367 622 318 602T233 544T178 457T159 349Q159 287 179 237T236 151T320 96T422 76Q448 76 465 77T494 80T516 84T534 88V300H387V382H634V19Q605 9 554 -1T421 -12Q338 -12 270 13T154 86T80 201T53 352Q53 433 80 499T157 612T274 684T422 710Q460 710 489 708T541 700T584 689T627 675L619 574Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 722,
    d: "M94 698H194V406H528V698H628V0H528V318H194V0H94V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 278,
    d: "M89 698H189V0H89V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 389,
    d: "M21 86Q38 80 54 78T84 76Q118 76 140 85T175 112T193 155T198 212V698H298V180Q298 143 289 109T257 47T197 4T102 -12Q52 -12 21 0V86Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 667,
    d: "M94 698H194V391L492 698H625L297 368L651 0H505L194 342V0H94V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 500,
    d: "M88 698H188V88H480V0H88V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 944,
    d: "M90 698H255L474 118L689 698H854V0H754V604H752L521 0H423L192 604H190V0H90V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 722,
    d: "M88 698H224L532 136H534V698H634V0H506L190 574H188V0H88V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 556,
    d: "M83 698H266Q320 698 367 688T450 653T507 589T528 489Q528 431 507 391T452 326T373 290T281 279H183V0H83V698ZM183 367H282Q305 367 330 373T375 394T409 431T422 490Q422 523 407 546T368 583T318 603T268 610H183V367Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 778,
    d: "M445 -8Q431 -10 418 -11T389 -12Q309 -12 247 14T141 89T76 203T53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 231 677 145T537 18L699 -129H575L445 -8ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 611,
    d: "M183 398H268Q340 398 379 427T419 507Q419 555 384 582T279 610H183V398ZM83 698H254Q306 698 354 692T441 666T502 609T525 509Q525 477 514 450T484 403T438 369T381 350V348Q404 339 418 325T449 278L581 0H467L360 242Q348 267 336 281T310 301T280 309T243 310H183V0H83V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 500,
    d: "M406 593Q387 600 372 605T341 615T310 620T275 622Q254 622 233 618T193 603T164 574T153 529Q153 495 175 474T230 434T303 399T375 355T431 291T453 196Q453 140 433 101T378 36T297 0T198 -12Q161 -12 126 -3T55 17L65 110Q78 105 95 99T131 88T170 80T210 76Q231 76 255 82T300 102T333 137T347 190Q347 229 325 253T270 296T197 332T125 372T69 431T47 520Q47 566 64 601T112 661T183 697T271 710Q306 710 345 704T420 685L406 593Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 556,
    d: "M228 610H11V698H545V610H328V0H228V610Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 722,
    d: "M632 289Q632 141 562 65T361 -12Q231 -12 161 64T90 289V698H190V302Q190 252 198 211T227 139T280 93T361 76Q409 76 442 92T495 139T523 210T532 302V698H632V289Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 667,
    d: "M394 0H269L6 698H118L333 88H335L556 698H661L394 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1000,
    d: "M2 698H112L279 100H281L430 698H572L723 100H725L892 698H998L783 0H654L502 610H500L347 0H213L2 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 667,
    d: "M265 363L31 698H151L337 430L522 698H636L401 365L659 0H533L327 296L128 0H8L265 363Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 667,
    d: "M284 292L11 698H128L336 385L539 698H656L384 292V0H284V292Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 556,
    d: "M32 90L394 610H44V698H509V608L148 88H515V0H32V90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 333,
    d: "M95 756H284V686H183V-70H284V-140H95V756Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 278,
    d: "M-25 710H63L303 -12H215L-25 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 333,
    d: "M238 -140H49V-70H150V686H49V756H238V-140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 600,
    d: "M259 698H341L540 294H450L300 606L150 294H60L259 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -75V-125H0V-75H500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 278,
    d: "M205 581H138L7 725H116L205 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 611,
    d: "M465 257Q466 291 459 325T434 386T390 429T325 446Q287 446 259 430T211 386T183 325T174 254Q174 222 182 189T209 127T255 82T324 64Q362 64 389 83T433 130T458 193T465 257ZM80 750H174V440H176Q198 475 238 498T345 522Q400 522 441 501T510 445T551 362T565 264Q565 211 553 162T514 74T446 12T346 -12Q312 -12 284 -4T234 16T197 43T172 72H170V0H80V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 444,
    d: "M404 424Q377 435 351 440T302 446Q263 446 233 430T181 387T149 326T138 255Q138 221 147 187T177 126T230 81T308 64Q332 64 359 71T409 93L416 9Q387 -5 356 -8T298 -12Q240 -12 193 9T111 66T57 151T38 255Q38 313 56 362T109 446T191 502T298 522Q327 522 359 516T412 502L404 424Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 611,
    d: "M146 257Q145 227 153 193T178 131T222 83T287 64Q327 64 355 81T402 127T428 188T437 254Q437 290 428 324T400 386T353 429T286 446Q248 446 221 430T177 387T153 326T146 257ZM441 72H439Q430 58 414 43T377 16T327 -4T265 -12Q207 -12 166 11T98 74T59 162T46 264Q46 315 59 362T100 444T169 501T266 522Q333 522 373 499T435 440H437V750H531V0H441V72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 556,
    d: "M410 304Q410 333 402 359T377 404T337 435T283 446Q248 446 224 433T183 400T158 354T146 304H410ZM471 21Q457 16 442 11T409 0T366 -8T310 -12Q242 -12 193 8T111 64T62 151T46 264Q46 321 63 368T111 449T187 503T285 522Q349 522 392 500T461 440T498 348T510 234H146Q146 196 159 165T196 112T250 77T314 64Q337 64 361 69T407 82T445 99T471 115V21Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 389,
    d: "M141 434H21V510H141V557Q141 603 148 641T174 706T226 747T312 762Q330 762 345 760T375 756L371 680Q363 683 351 684T326 686Q296 686 278 677T251 652T238 613T235 565V510H370V434H235V0H141V434Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 611,
    d: "M288 76Q321 76 348 89T395 126T426 181T437 249Q437 289 428 324T400 387T353 430T288 446Q252 446 226 429T182 384T155 323T146 256Q146 220 156 188T184 130T228 91T288 76ZM531 22Q531 -94 468 -158T268 -222Q248 -222 229 -221T187 -215T141 -205T85 -187L95 -100Q122 -112 144 -121T188 -135T231 -143T279 -146Q354 -146 395 -99T437 29V79H435Q405 39 359 20T264 0Q209 0 168 20T100 76T60 156T46 251Q46 300 60 348T102 435T173 498T274 522Q342 522 381 499T442 434H444V510H531V22Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 611,
    d: "M80 750H174V437H176Q202 478 244 500T340 522Q439 522 485 464T531 303V0H437V264Q437 354 414 398T329 446Q289 446 260 431T211 388T183 321T174 236V0H80V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 278,
    d: "M192 624H86V730H192V624ZM92 510H186V0H92V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 278,
    d: "M192 624H86V730H192V624ZM-13 -137Q-4 -139 3 -139T25 -140Q58 -140 75 -111T92 -32V510H186V-18Q186 -46 184 -81T167 -147T124 -200T42 -222Q27 -222 11 -221T-16 -218L-13 -137Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 556,
    d: "M80 750H174V303L379 510H507L270 284L537 0H402L174 262V0H80V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 278,
    d: "M92 750H186V0H92V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 889,
    d: "M79 510H167V436H169Q196 481 235 501T331 522Q375 522 415 499T476 423Q489 450 509 469T551 500T595 517T634 522Q683 522 716 507T771 466T801 405T811 327V0H717V304Q717 328 714 353T700 398T672 432T626 446Q590 446 565 430T523 388T500 327T492 257V0H398V304Q398 328 395 353T381 398T353 432T307 446Q271 446 246 430T204 388T181 327T173 257V0H79V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 611,
    d: "M80 510H171V429H173Q194 473 240 497T340 522Q439 522 485 464T531 303V0H437V264Q437 354 414 398T329 446Q289 446 260 431T211 388T183 321T174 236V0H80V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 611,
    d: "M465 257Q466 291 459 325T434 386T390 429T325 446Q287 446 259 430T211 386T183 325T174 254Q174 222 182 189T209 127T255 82T324 64Q362 64 389 83T433 130T458 193T465 257ZM80 510H170V438H172Q181 452 196 467T234 494T283 514T345 522Q400 522 441 501T510 445T551 362T565 264Q565 211 553 162T514 74T446 12T346 -12Q278 -12 238 11T176 70H174V-210H80V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 611,
    d: "M146 257Q145 227 153 193T178 131T222 83T287 64Q327 64 355 81T402 127T428 188T437 254Q437 290 428 324T400 386T353 429T286 446Q248 446 221 430T177 387T153 326T146 257ZM531 -210H437V67H435Q413 31 368 10T265 -12Q207 -12 166 11T98 74T59 162T46 264Q46 315 59 362T100 444T169 501T266 522Q300 522 327 514T377 494T414 467T439 437H441V510H531V-210Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 389,
    d: "M80 510H168V431H170Q189 471 225 496T303 522Q324 522 337 520T365 515V431Q352 436 339 438T313 440Q250 440 212 384T174 232V0H80V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 389,
    d: "M42 100Q56 91 72 84T104 73T134 66T159 64Q175 64 192 67T223 79T246 102T255 137Q255 160 239 176T198 205T145 232T92 263T51 305T34 365Q34 405 48 434T86 483T143 512T214 522Q247 522 275 516T331 502L323 420Q315 425 302 429T274 438T246 444T224 446Q188 446 161 431T134 384Q134 358 150 342T191 313T244 288T297 258T338 214T355 147Q355 106 340 76T300 27T243 -2T177 -12Q141 -12 105 -7T37 16L42 100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 389,
    d: "M351 434H216V155Q216 110 239 87T295 64Q317 64 332 69T359 82V2Q343 -3 323 -7T279 -12Q206 -12 164 23T122 136V434H7V510H122V628L216 658V510H351V434Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q172 -12 126 46T80 207V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 500,
    d: "M306 0H194L11 510H114L252 94H254L395 510H489L306 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 833,
    d: "M657 0H548L416 428H414L285 0H176L12 510H115L232 88H234L364 510H475L603 88H605L729 510H821L657 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 500,
    d: "M194 267L28 510H145L256 328L369 510H474L310 267L490 0H374L248 200L122 0H10L194 267Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 500,
    d: "M42 -138Q51 -141 62 -143T86 -146Q117 -146 138 -128T173 -87T192 -44T198 -20Q198 -12 192 4T180 34L7 510H110L247 88H249L389 510H484L296 -11Q283 -48 268 -85T232 -153T178 -203T100 -222Q77 -222 63 -220T36 -215L42 -138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 500,
    d: "M43 82L337 434H57V510H446V428L152 76H457V0H43V82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 333,
    d: "M314 686H261Q246 686 236 680T221 662T213 638T211 610V429Q211 396 201 374T175 338T145 318T119 309V307Q129 306 144 300T175 281T200 244T211 184V6Q211 -8 213 -21T220 -46T236 -63T261 -70H314V-140H236Q218 -140 198 -132T162 -108T134 -69T123 -14V168Q123 193 115 213T95 246T68 266T37 273V343Q52 343 67 350T95 369T115 400T123 443V630Q123 661 134 684T161 724T198 748T236 756H314V686Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 222,
    d: "M155 750V-250H67V750H155Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 333,
    d: "M19 -70H72Q87 -70 97 -64T112 -46T120 -22T122 6V187Q122 220 132 242T158 278T188 298T214 307V309Q204 310 189 316T158 335T133 372T122 432V610Q122 624 120 637T113 662T97 679T72 686H19V756H97Q115 756 135 748T171 724T199 685T210 630V448Q210 422 218 403T238 370T265 350T296 343V273Q281 273 266 266T238 247T218 216T210 173V-14Q210 -45 199 -68T172 -108T135 -132T97 -140H19V-70Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 600,
    d: "M531 263Q523 247 512 232T485 205T451 186T406 178Q380 178 352 187T295 209Q267 221 240 233T193 246Q178 246 166 240T143 223T123 199T105 173L69 243Q77 259 88 274T115 301T149 320T194 328Q220 328 248 319T305 297Q333 285 360 273T407 260Q422 260 434 266T457 283T477 307T495 333L531 263Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 389,
    d: "M139 510H251V398H139V510ZM251 -188H139L152 314H238L251 -188Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 556,
    d: "M219 23Q157 58 123 119T89 255Q89 313 107 362T160 446T242 502T349 522Q352 522 355 522Q359 522 363 521L396 634H453L418 515Q432 512 443 509T463 502L455 424Q425 437 397 441L292 76Q306 71 323 68T359 64Q383 64 410 71T460 93L467 9Q438 -5 407 -8T349 -12Q306 -12 270 0L231 -133H174L219 23ZM341 445Q304 442 276 425T229 382T199 323T189 255Q189 216 202 177T244 109L341 445Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 556,
    d: "M59 88H150V348H71V406H150V462Q150 516 165 561T211 640T287 691T392 710Q430 710 458 705T510 691L502 598Q482 607 458 614T402 622Q324 622 287 578T250 455V406H411V348H250V88H497V0H59V88Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 556,
    d: "M118 349Q118 314 130 284T165 232T216 196T278 183Q312 183 341 196T392 233T426 286T438 349Q438 382 426 412T393 465T342 501T278 515Q245 515 216 502T165 467T131 414T118 349ZM80 203Q55 232 43 269T30 349Q30 390 42 429T80 497L24 551L75 603L130 548Q159 571 198 584T278 597Q320 597 359 584T428 548L482 603L532 551L478 497Q502 470 514 431T526 349Q526 308 514 270T478 203L532 146L482 95L428 152Q399 127 360 114T278 101Q236 101 198 113T130 152L75 95L24 146L80 203Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 556,
    d: "M229 162H88V220H229V292L221 308H88V366H189L6 698H117L281 385L439 698H550L369 366H470V308H337L329 292V220H470V162H329V0H229V162Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 222,
    d: "M155 175V-175H67V175H155ZM155 675V325H67V675H155Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 556,
    d: "M172 324Q172 294 194 274T246 240T307 217T359 198Q373 215 384 232T395 273Q395 304 374 324T322 357T261 381T209 402Q172 374 172 324ZM98 -7Q134 -26 176 -34T263 -42Q284 -42 305 -37T344 -20T371 8T382 49Q382 75 360 91T305 120T233 146T161 178T106 228T84 305Q84 348 102 377T157 429Q123 448 106 478T88 548Q88 590 107 620T156 671T224 700T298 710Q335 710 370 705T442 691L433 600Q406 612 373 620T311 628Q293 628 271 625T229 614T196 591T182 552Q182 522 204 504T260 473T332 447T405 415T460 367T483 292Q483 247 464 220T412 166Q441 147 458 117T476 52Q476 4 455 -29T400 -84T327 -114T250 -124Q211 -124 171 -119T89 -99L98 -7Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 277,
    d: "M174 730H268V624H174V730ZM10 730H104V624H10V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M127 349Q127 286 148 233T207 140T293 80T400 58Q457 58 506 79T593 140T651 232T673 349Q673 412 652 465T593 558T507 618T400 640Q343 640 294 619T207 558T149 466T127 349ZM39 349Q39 424 67 489T145 604T259 681T400 710Q475 710 540 682T655 604T732 490T761 349Q761 274 733 209T655 94T541 17T400 -12Q325 -12 260 16T145 94T68 208T39 349ZM582 285Q570 210 522 170T409 129Q362 129 324 146T260 192T219 262T204 349Q204 396 217 436T257 505T320 550T406 567Q439 567 469 557T522 528T561 481T582 417H509Q501 454 474 475T407 497Q375 497 352 486T312 456T288 409T280 351Q280 318 289 291T314 243T355 211T409 199Q450 199 477 221T509 285H582Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 361,
    d: "M212 535Q197 535 179 534T144 526T116 510T105 481Q105 463 124 455T164 446Q206 446 229 460T252 506V533Q245 533 236 534T212 535ZM63 682Q92 697 121 703T180 710Q215 710 243 705T292 686T323 647T334 583V455Q334 429 336 416T337 396H253V434H251Q234 408 209 398T153 388Q134 388 112 392T70 407T37 436T23 484Q23 516 41 536T85 567T140 583T191 587Q209 587 223 587Q237 587 252 585Q252 605 246 618T230 638T205 649T174 652Q143 652 117 645T66 619L63 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 556,
    d: "M253 269L396 471H484L354 269L484 67H396L253 269ZM51 269L194 471H282L152 269L282 67H194L51 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 600,
    d: "M47 402H553V104H465V314H47V402Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M38 307H295V231H38V307Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M337 380H404Q421 380 436 382T462 390T481 408T488 441Q488 459 481 470T461 487T435 495T405 497H337V380ZM261 555H413Q487 555 525 528T564 435Q564 382 536 356T457 325L567 146H489L383 322H337V146H261V555ZM400 58Q457 58 506 79T593 140T651 232T673 349Q673 412 652 465T593 558T507 618T400 640Q343 640 294 619T207 558T149 466T127 349Q127 286 148 233T207 140T293 80T400 58ZM400 -12Q325 -12 260 16T145 94T68 208T39 349Q39 424 67 489T145 604T259 681T400 710Q475 710 540 682T655 604T732 490T761 349Q761 274 733 209T655 94T541 17T400 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 278,
    d: "M-9 673H287V615H-9V673Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 400,
    d: "M121 567Q121 534 144 511T200 488Q233 488 256 511T279 567Q279 600 256 623T200 646Q167 646 144 623T121 567ZM57 567Q57 597 68 623T98 668T144 699T200 710Q230 710 256 699T301 669T332 623T343 567Q343 537 332 511T302 466T256 435T200 424Q170 424 144 435T99 465T68 511T57 567Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 600,
    d: "M47 88H553V0H47V88ZM47 359H256V506H344V359H553V271H344V124H256V271H47V359Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 361,
    d: "M31 358Q41 366 60 381T102 415T148 456T191 500T222 544T235 585Q235 600 227 610T207 627T181 637T155 640Q129 640 102 633T51 611L45 685Q104 710 170 710Q199 710 226 704T275 683T310 645T323 589Q323 558 300 521T245 450T181 390T131 354V352H330V282H31V358Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 361,
    d: "M93 536H139Q153 536 170 539T202 549T227 567T238 593Q238 607 229 616T207 630T178 638T149 640Q121 640 97 634T52 618L48 690Q71 698 103 704T171 710Q201 710 228 704T278 684T313 649T326 597Q326 576 318 560T295 532T262 513T226 502V500Q271 494 300 468T330 395Q330 357 314 334T271 298T211 281T145 276Q111 276 83 281T32 292L42 368Q46 364 56 360T78 353T106 348T136 346Q150 346 168 348T202 356T230 372T242 399Q242 416 233 428T208 449T176 462T142 466H93V536Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 278,
    d: "M162 725H271L140 581H73L162 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q242 -12 218 -8T174 8V-210H80V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 600,
    d: "M236 333Q186 333 146 346T78 383T35 440T20 512Q20 563 37 598T85 656T160 688T256 698H527V-112H439V628H324V-112H236V333Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 278,
    d: "M80 304Q81 328 98 345T140 362Q164 362 181 345T198 304Q199 280 182 262T140 244Q116 244 99 262T80 304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 278,
    d: "M247 0L201 -60L203 -62Q216 -57 233 -57Q267 -57 291 -76T316 -130Q316 -155 304 -172T273 -201T231 -217T185 -222Q163 -222 142 -217T101 -201L119 -167Q136 -174 150 -178T184 -182Q203 -182 221 -173T240 -136Q240 -116 226 -107T194 -97Q183 -97 172 -99T153 -105L136 -86L200 0H247Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 361,
    d: "M154 628L84 573L50 619L161 704H242V282H154V628Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 397,
    d: "M108 549Q108 529 112 511T127 478T155 455T198 446Q224 446 241 454T269 477T284 510T288 549Q288 591 267 621T198 652Q151 652 130 622T108 549ZM198 388Q159 388 128 401T74 435T39 486T26 549Q26 584 38 613T72 664T127 698T198 710Q237 710 269 698T323 665T358 614T370 549Q370 516 358 487T323 436T269 401T198 388Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 556,
    d: "M303 269L160 67H72L202 269L72 471H160L303 269ZM505 269L362 67H274L404 269L274 471H362L505 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 834,
    d: "M661 83H449V144L633 422H749V153H801V83H749V0H661V83ZM661 352H659L531 153H661V352ZM137 628L67 573L33 619L144 704H225V282H137V628ZM576 720H648L215 -22H143L576 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 834,
    d: "M502 76Q512 84 531 99T573 133T619 174T662 218T693 262T706 303Q706 318 698 328T678 345T652 355T626 358Q600 358 573 351T522 329L516 403Q575 428 641 428Q670 428 697 422T746 401T781 363T794 307Q794 276 771 239T716 168T652 108T602 72V70H801V0H502V76ZM137 628L67 573L33 619L144 704H225V282H137V628ZM545 720H617L184 -22H112L545 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 834,
    d: "M661 83H449V144L633 422H749V153H801V83H749V0H661V83ZM661 352H659L531 153H661V352ZM93 536H139Q153 536 170 539T202 549T227 567T238 593Q238 607 229 616T207 630T178 638T149 640Q121 640 97 634T52 618L48 690Q71 698 103 704T171 710Q201 710 228 704T278 684T313 649T326 597Q326 576 318 560T295 532T262 513T226 502V500Q271 494 300 468T330 395Q330 357 314 334T271 298T211 281T145 276Q111 276 83 281T32 292L42 368Q46 364 56 360T78 353T106 348T136 346Q150 346 168 348T202 356T230 372T242 399Q242 416 233 428T208 449T176 462T142 466H93V536ZM619 720H691L258 -22H186L619 720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 500,
    d: "M305 398H193V510H305V398ZM296 293Q296 269 293 251T283 215T264 182T234 144Q220 128 206 111T179 75T158 35T150 -11Q150 -37 160 -56T187 -87T225 -106T271 -112Q321 -112 357 -101T419 -72L426 -167Q393 -181 352 -190T260 -200Q219 -200 180 -189T111 -154T63 -97T44 -18Q44 21 58 52T92 111T137 166T181 223Q193 241 197 258T202 296V314H296V293Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM427 749H360L229 893H338L427 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM382 893H491L360 749H293L382 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM315 893H406L506 749H426L360 847L295 749H216L315 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM191 754Q193 770 198 789T214 826T242 854T285 866Q304 866 325 859T366 843T404 827T439 820Q462 818 472 833T485 866H531Q529 850 524 831T508 794T480 766T437 754Q417 754 397 761T356 777T318 793T283 800Q260 802 250 787T237 754H191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM396 856H490V756H396V856ZM232 856H326V756H232V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 722,
    d: "M359 604L220 258H498L359 604ZM310 698H415L710 0H601L530 176H188L117 0H12L310 698ZM361 895Q336 895 318 877T299 833Q299 808 317 790T361 771Q385 771 404 790T423 833Q423 858 405 876T361 895ZM361 935Q382 935 400 927T433 905T455 873T463 833Q463 812 455 794T433 761T401 739T361 731Q340 731 322 739T289 761T267 793T259 833Q259 854 267 872T289 905T321 927T361 935Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 944,
    d: "M488 628H486L266 258H510L488 628ZM424 698H485H581H863V610H586L599 406H845V318H604L618 88H873V0H624H526L515 176H218L113 0H2L424 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 611,
    d: "M571 583Q505 622 427 622Q367 622 318 602T233 545T178 458T159 349Q159 287 179 237T236 151T320 96T422 76Q441 76 462 78T503 85T542 96T574 110L580 13Q540 -4 496 -8T421 -12Q415 -12 409 -12Q404 -12 398 -10L360 -60L362 -62Q375 -57 392 -57Q426 -57 450 -76T475 -130Q475 -155 463 -172T432 -201T390 -217T344 -222Q322 -222 301 -217T260 -201L278 -167Q295 -174 309 -178T343 -182Q362 -182 380 -173T399 -136Q399 -116 385 -107T353 -97Q342 -97 331 -99T312 -105L295 -86L353 -7Q284 3 229 32T134 108T74 216T53 352Q53 433 80 499T157 612T274 684T422 710Q463 710 502 704T579 680L571 583Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 556,
    d: "M94 698H485V610H194V406H459V318H194V88H485V0H94V698ZM345 749H278L147 893H256L345 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 556,
    d: "M94 698H485V610H194V406H459V318H194V88H485V0H94V698ZM301 893H410L279 749H212L301 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 556,
    d: "M94 698H485V610H194V406H459V318H194V88H485V0H94V698ZM232 893H323L423 749H343L277 847L212 749H133L232 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 556,
    d: "M94 698H485V610H194V406H459V318H194V88H485V0H94V698ZM312 856H406V756H312V856ZM148 856H242V756H148V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 278,
    d: "M89 698H189V0H89V698ZM205 749H138L7 893H116L205 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 278,
    d: "M89 698H189V0H89V698ZM162 893H271L140 749H73L162 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 278,
    d: "M89 698H189V0H89V698ZM93 893H184L284 749H204L138 847L73 749H-6L93 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 278,
    d: "M89 698H189V0H89V698ZM174 856H268V756H174V856ZM10 856H104V756H10V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 722,
    d: "M83 342H15V406H83V698H289Q367 698 434 675T552 607T632 500T661 355Q661 267 635 201T561 90T444 23T289 0H83V342ZM183 406H366V342H183V88H288Q417 88 486 152T555 351Q555 407 537 454T484 536T403 590T298 610H183V406Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 722,
    d: "M88 698H224L532 136H534V698H634V0H506L190 574H188V0H88V698ZM191 754Q193 770 198 789T214 826T242 854T285 866Q304 866 325 859T366 843T404 827T439 820Q462 818 472 833T485 866H531Q529 850 524 831T508 794T480 766T437 754Q417 754 397 761T356 777T318 793T283 800Q260 802 250 787T237 754H191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349ZM455 749H388L257 893H366L455 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349ZM412 893H521L390 749H323L412 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349ZM343 893H434L534 749H454L388 847L323 749H244L343 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349ZM219 754Q221 770 226 789T242 826T270 854T313 866Q332 866 353 859T394 843T432 827T467 820Q490 818 500 833T513 866H559Q557 850 552 831T536 794T508 766T465 754Q445 754 425 761T384 777T346 793T311 800Q288 802 278 787T265 754H219Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 778,
    d: "M53 349Q53 427 75 493T141 607T247 682T389 710Q468 710 530 683T636 607T702 493T725 349Q725 269 703 203T637 89T532 15T389 -12Q309 -12 247 14T141 89T76 203T53 349ZM159 349Q159 297 172 248T214 161T285 99T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 451T562 539T490 599T389 622Q331 622 288 600T217 539T174 452T159 349ZM425 856H519V756H425V856ZM261 856H355V756H261V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 600,
    d: "M68 423L130 485L300 314L470 485L532 423L361 253L532 83L470 21L300 192L130 21L68 83L238 253L68 423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 778,
    d: "M246 126Q272 103 308 90T389 76Q449 76 492 99T564 160T605 248T619 349Q619 402 605 450T563 537L246 126ZM151 79Q103 127 78 195T53 349Q53 427 75 493T141 607T247 682T389 710Q449 710 499 694T591 648L644 717L680 689L626 618Q675 568 700 500T725 349Q725 269 703 203T637 89T532 15T389 -12Q268 -12 186 49L132 -21L94 5L151 79ZM532 572Q505 595 470 609T389 622Q331 622 288 600T217 539T174 452T159 349Q159 297 172 248T214 160L532 572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 722,
    d: "M632 289Q632 141 562 65T361 -12Q231 -12 161 64T90 289V698H190V302Q190 252 198 211T227 139T280 93T361 76Q409 76 442 92T495 139T523 210T532 302V698H632V289ZM426 749H359L228 893H337L426 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 722,
    d: "M632 289Q632 141 562 65T361 -12Q231 -12 161 64T90 289V698H190V302Q190 252 198 211T227 139T280 93T361 76Q409 76 442 92T495 139T523 210T532 302V698H632V289ZM385 893H494L363 749H296L385 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 722,
    d: "M632 289Q632 141 562 65T361 -12Q231 -12 161 64T90 289V698H190V302Q190 252 198 211T227 139T280 93T361 76Q409 76 442 92T495 139T523 210T532 302V698H632V289ZM315 893H406L506 749H426L360 847L295 749H216L315 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 722,
    d: "M632 289Q632 141 562 65T361 -12Q231 -12 161 64T90 289V698H190V302Q190 252 198 211T227 139T280 93T361 76Q409 76 442 92T495 139T523 210T532 302V698H632V289ZM396 856H490V756H396V856ZM232 856H326V756H232V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 667,
    d: "M284 292L11 698H128L336 385L539 698H656L384 292V0H284V292ZM357 893H466L335 749H268L357 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 556,
    d: "M183 265H282Q305 265 330 271T375 292T409 329T422 388Q422 421 407 444T368 481T318 501T268 508H183V265ZM83 698H183V596H266Q320 596 367 586T450 551T507 487T528 387Q528 329 507 289T452 224T373 188T281 177H183V0H83V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 611,
    d: "M80 0V474Q80 542 93 595T135 686T210 742T325 762Q361 762 397 750T462 714T510 652T528 566Q528 439 411 403V401Q447 397 474 380T521 338T550 281T560 217Q560 171 546 131T503 60T433 12T339 -6Q314 -6 291 -3T242 8V87Q281 70 321 70Q349 70 374 79T419 107T449 151T460 213Q460 256 446 284T407 328T348 351T272 357V433Q307 433 336 439T385 460T417 500T428 563Q428 587 421 609T399 648T364 676T316 686Q274 686 247 668T203 622T181 558T174 489V0H80Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM344 581H277L146 725H255L344 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM301 725H410L279 581H212L301 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM232 725H323L423 581H343L277 679L212 581H133L232 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM108 586Q110 602 115 621T131 658T159 686T202 698Q221 698 242 691T283 675T321 659T356 652Q379 650 389 665T402 698H448Q446 682 441 663T425 626T397 598T354 586Q334 586 314 593T273 609T235 625T200 632Q177 634 167 619T154 586H108Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM313 730H407V624H313V730ZM149 730H243V624H149V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 556,
    d: "M383 243Q368 243 353 244T323 245Q304 245 274 243T216 230T167 201T146 147Q146 127 155 112T177 86T208 70T241 64Q311 64 347 102T383 198V243ZM104 474Q139 495 181 508T272 522Q382 522 429 469T477 311V100Q477 56 478 34T481 0H393V66H391Q383 54 369 41T336 16T291 -4T233 -12Q192 -12 158 -3T98 25T60 75T46 147Q46 195 69 227T128 278T205 306T283 315Q311 315 333 315Q355 315 383 313Q383 379 356 412T257 446Q217 446 178 432T109 394L104 474ZM278 727Q253 727 235 709T216 665Q216 640 234 622T278 603Q302 603 321 622T340 665Q340 690 322 708T278 727ZM278 767Q299 767 317 759T350 737T372 705T380 665Q380 644 372 626T350 593T318 571T278 563Q257 563 239 571T206 593T184 625T176 665Q176 686 184 704T206 737T238 759T278 767Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 889,
    d: "M748 304Q748 329 740 354T715 400T675 433T623 446Q592 446 567 435T524 405T497 360T487 304H748ZM141 148Q141 127 149 111T172 85T204 69T241 64Q275 64 303 78T351 117T382 174T393 242Q382 242 360 243T303 245Q283 245 256 242T203 229T159 200T141 148ZM102 473Q135 494 178 508T271 522Q296 522 322 517T371 502T414 474T447 433Q474 481 522 501T624 522Q689 522 732 498T801 434T837 342T848 234H487Q487 199 499 168T534 114T587 78T654 64Q692 64 730 79T795 117V22Q762 7 725 -2T649 -12Q616 -12 583 -6T519 13T465 50T429 107H427Q419 77 400 55T356 17T300 -5T238 -12Q202 -12 167 -1T104 30T59 81T41 151Q41 204 67 236T131 285T211 309T287 315Q328 315 353 312T393 310Q393 347 382 373T351 415T305 438T249 446Q212 446 174 431T107 394L102 473Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 444,
    d: "M404 424Q377 435 351 440T302 446Q263 446 233 430T181 387T149 326T138 255Q138 221 147 187T177 126T230 81T308 64Q332 64 359 71T409 93L416 9Q387 -5 356 -8T298 -12H294L257 -60L259 -62Q272 -57 289 -57Q323 -57 347 -76T372 -130Q372 -155 360 -172T329 -201T287 -217T241 -222Q219 -222 198 -217T157 -201L175 -167Q192 -174 206 -178T240 -182Q259 -182 277 -173T296 -136Q296 -116 282 -107T250 -97Q239 -97 228 -99T209 -105L192 -86L251 -7Q203 1 164 24T97 83T54 162T38 255Q38 313 56 362T109 446T191 502T298 522Q327 522 359 516T412 502L404 424Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 556,
    d: "M410 304Q410 333 402 359T377 404T337 435T283 446Q248 446 224 433T183 400T158 354T146 304H410ZM471 21Q457 16 442 11T409 0T366 -8T310 -12Q242 -12 193 8T111 64T62 151T46 264Q46 321 63 368T111 449T187 503T285 522Q349 522 392 500T461 440T498 348T510 234H146Q146 196 159 165T196 112T250 77T314 64Q337 64 361 69T407 82T445 99T471 115V21ZM344 581H277L146 725H255L344 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 556,
    d: "M410 304Q410 333 402 359T377 404T337 435T283 446Q248 446 224 433T183 400T158 354T146 304H410ZM471 21Q457 16 442 11T409 0T366 -8T310 -12Q242 -12 193 8T111 64T62 151T46 264Q46 321 63 368T111 449T187 503T285 522Q349 522 392 500T461 440T498 348T510 234H146Q146 196 159 165T196 112T250 77T314 64Q337 64 361 69T407 82T445 99T471 115V21ZM301 725H410L279 581H212L301 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 556,
    d: "M410 304Q410 333 402 359T377 404T337 435T283 446Q248 446 224 433T183 400T158 354T146 304H410ZM471 21Q457 16 442 11T409 0T366 -8T310 -12Q242 -12 193 8T111 64T62 151T46 264Q46 321 63 368T111 449T187 503T285 522Q349 522 392 500T461 440T498 348T510 234H146Q146 196 159 165T196 112T250 77T314 64Q337 64 361 69T407 82T445 99T471 115V21ZM232 725H323L423 581H343L277 679L212 581H133L232 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 556,
    d: "M410 304Q410 333 402 359T377 404T337 435T283 446Q248 446 224 433T183 400T158 354T146 304H410ZM471 21Q457 16 442 11T409 0T366 -8T310 -12Q242 -12 193 8T111 64T62 151T46 264Q46 321 63 368T111 449T187 503T285 522Q349 522 392 500T461 440T498 348T510 234H146Q146 196 159 165T196 112T250 77T314 64Q337 64 361 69T407 82T445 99T471 115V21ZM313 730H407V624H313V730ZM149 730H243V624H149V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 278,
    d: "M92 510H186V0H92V510ZM205 581H138L7 725H116L205 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 278,
    d: "M92 510H186V0H92V510ZM162 725H271L140 581H73L162 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 278,
    d: "M92 510H186V0H92V510ZM93 725H184L284 581H204L138 679L73 581H-6L93 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 278,
    d: "M92 510H186V0H92V510ZM174 730H268V624H174V730ZM10 730H104V624H10V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 611,
    d: "M218 651Q187 670 155 684T93 709L165 762Q200 749 235 733T302 696L424 762L470 709L366 653Q408 621 444 580T507 489T549 380T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255Q46 313 64 362T117 446T199 502T306 522Q332 522 353 516T390 500H392Q345 563 283 608L154 539L108 592L218 651ZM146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 611,
    d: "M80 510H171V429H173Q194 473 240 497T340 522Q439 522 485 464T531 303V0H437V264Q437 354 414 398T329 446Q289 446 260 431T211 388T183 321T174 236V0H80V510ZM136 586Q138 602 143 621T159 658T187 686T230 698Q249 698 270 691T311 675T349 659T384 652Q407 650 417 665T430 698H476Q474 682 469 663T453 626T425 598T382 586Q362 586 342 593T301 609T263 625T228 632Q205 634 195 619T182 586H136Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255ZM372 581H305L174 725H283L372 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255ZM329 725H438L307 581H240L329 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255ZM260 725H351L451 581H371L305 679L240 581H161L260 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255ZM136 586Q138 602 143 621T159 658T187 686T230 698Q249 698 270 691T311 675T349 659T384 652Q407 650 417 665T430 698H476Q474 682 469 663T453 626T425 598T382 586Q362 586 342 593T301 609T263 625T228 632Q205 634 195 619T182 586H136Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 611,
    d: "M146 255Q146 221 155 187T184 126T234 81T306 64Q347 64 377 81T426 125T455 187T465 255Q465 291 454 325T423 387T373 430T306 446Q268 446 239 430T189 387T157 326T146 255ZM46 255Q46 313 64 362T117 446T199 502T306 522Q364 522 412 502T494 447T546 362T565 255Q565 200 546 152T493 67T411 9T306 -12Q248 -12 201 9T119 66T65 151T46 255ZM341 730H435V624H341V730ZM177 730H271V624H177V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 600,
    d: "M224 46Q224 78 246 100T301 122Q331 122 354 100T377 46Q377 32 371 18T355 -7T331 -24T302 -31Q286 -31 272 -25T247 -8T230 17T224 46ZM224 460Q224 492 246 514T301 537Q316 537 329 531T353 514T370 489T377 460Q377 446 371 432T355 408T331 391T302 384Q286 384 272 390T247 406T230 431T224 460ZM47 297H553V209H47V297Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 611,
    d: "M121 65Q85 102 66 150T46 255Q46 313 64 362T117 446T199 502T306 522Q396 522 459 476L512 541L542 516L489 451Q526 415 545 365T565 255Q565 200 546 152T493 67T411 9T306 -12Q260 -12 221 1T151 38L94 -31L64 -6L121 65ZM204 103Q223 85 248 75T306 64Q347 64 377 81T426 125T455 187T465 255Q465 325 429 378L204 103ZM403 408Q384 426 360 436T306 446Q268 446 239 430T189 387T157 326T146 255Q146 224 154 193T179 135L403 408Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q172 -12 126 46T80 207V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0ZM372 581H305L174 725H283L372 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q172 -12 126 46T80 207V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0ZM329 725H438L307 581H240L329 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q172 -12 126 46T80 207V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0ZM260 725H351L451 581H371L305 679L240 581H161L260 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 611,
    d: "M531 0H440V81H438Q417 37 371 13T271 -12Q172 -12 126 46T80 207V510H174V246Q174 156 197 112T282 64Q322 64 351 79T400 122T428 188T437 274V510H531V0ZM341 730H435V624H341V730ZM177 730H271V624H177V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 500,
    d: "M42 -138Q51 -141 62 -143T86 -146Q117 -146 138 -128T173 -87T192 -44T198 -20Q198 -12 192 4T180 34L7 510H110L247 88H249L389 510H484L296 -11Q283 -48 268 -85T232 -153T178 -203T100 -222Q77 -222 63 -220T36 -215L42 -138ZM273 725H382L251 581H184L273 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 611,
    d: "M465 257Q466 291 459 325T434 386T390 429T325 446Q287 446 259 430T211 386T183 325T174 254Q174 222 182 189T209 127T255 82T324 64Q362 64 389 83T433 130T458 193T465 257ZM80 750H174V440H176Q198 475 238 498T345 522Q400 522 441 501T510 445T551 362T565 264Q565 211 553 162T514 74T446 12T346 -12Q278 -12 238 11T176 70H174V-210H80V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 500,
    d: "M42 -138Q51 -141 62 -143T86 -146Q117 -146 138 -128T173 -87T192 -44T198 -20Q198 -12 192 4T180 34L7 510H110L247 88H249L389 510H484L296 -11Q283 -48 268 -85T232 -153T178 -203T100 -222Q77 -222 63 -220T36 -215L42 -138ZM285 730H379V624H285V730ZM121 730H215V624H121V730Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0131",
    horizAdvX: 278,
    d: "M92 510H186V0H92V510Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 944,
    d: "M875 610H593V406H855V318H593V88H882V0H592Q553 0 514 -3T436 -6Q353 -6 283 18T161 89T82 204T53 358Q53 437 81 501T160 610T281 679T438 704Q475 704 511 701T584 698H875V610ZM493 610Q478 612 463 614T432 616Q369 616 319 599T233 550T178 469T159 358Q159 292 179 241T235 154T322 101T433 82Q448 82 463 83T493 88V610Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 944,
    d: "M803 304Q803 329 795 354T770 400T730 433T678 446Q647 446 622 435T579 405T552 360T542 304H803ZM141 255Q141 218 149 184T176 123T224 80T295 64Q332 64 360 81T408 125T438 187T448 255Q448 286 439 320T411 382T364 428T295 446Q255 446 226 428T178 382T150 320T141 255ZM850 22Q817 7 780 -2T704 -12Q631 -12 576 14T494 98Q480 68 458 47T408 13T352 -6T294 -12Q235 -12 188 8T109 64T59 149T41 255Q41 306 58 354T108 440T188 499T294 522Q364 522 417 497T497 422Q521 473 569 497T679 522Q744 522 787 498T856 434T892 342T903 234H542Q542 199 554 168T589 114T642 78T709 64Q747 64 785 79T850 117V22Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0160",
    horizAdvX: 500,
    d: "M406 593Q387 600 372 605T341 615T310 620T275 622Q254 622 233 618T193 603T164 574T153 529Q153 495 175 474T230 434T303 399T375 355T431 291T453 196Q453 140 433 101T378 36T297 0T198 -12Q161 -12 126 -3T55 17L65 110Q78 105 95 99T131 88T170 80T210 76Q231 76 255 82T300 102T333 137T347 190Q347 229 325 253T270 296T197 332T125 372T69 431T47 520Q47 566 64 601T112 661T183 697T271 710Q306 710 345 704T420 685L406 593ZM296 749H205L105 893H185L251 795L316 893H395L296 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0161",
    horizAdvX: 389,
    d: "M42 100Q56 91 72 84T104 73T134 66T159 64Q175 64 192 67T223 79T246 102T255 137Q255 160 239 176T198 205T145 232T92 263T51 305T34 365Q34 405 48 434T86 483T143 512T214 522Q247 522 275 516T331 502L323 420Q315 425 302 429T274 438T246 444T224 446Q188 446 161 431T134 384Q134 358 150 342T191 313T244 288T297 258T338 214T355 147Q355 106 340 76T300 27T243 -2T177 -12Q141 -12 105 -7T37 16L42 100ZM241 581H150L50 725H130L196 627L261 725H340L241 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 667,
    d: "M284 292L11 698H128L336 385L539 698H656L384 292V0H284V292ZM369 857H463V757H369V857ZM205 857H299V757H205V857Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017D",
    horizAdvX: 556,
    d: "M32 90L394 610H44V698H509V608L148 88H515V0H32V90ZM324 749H233L133 893H213L279 795L344 893H423L324 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017E",
    horizAdvX: 500,
    d: "M43 82L337 434H57V510H446V428L152 76H457V0H43V82ZM296 581H205L105 725H185L251 627L316 725H395L296 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0192",
    horizAdvX: 556,
    d: "M461 344H335L266 -24Q258 -67 248 -103T219 -165T167 -207T84 -222Q66 -222 55 -221T33 -217L49 -136Q56 -138 62 -139T79 -140Q103 -140 118 -131T142 -107T157 -73T166 -34L237 344H125L138 414H250L271 523Q278 560 289 593T320 653T371 694T450 710Q469 710 487 707T523 702L509 622Q498 624 489 626T468 628Q440 628 424 620T397 597T381 562T370 518L349 414H475L461 344Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 278,
    d: "M93 725H184L284 581H204L138 679L73 581H-6L93 725Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C7",
    horizAdvX: 278,
    d: "M185 581H94L-6 725H74L140 627L205 725H284L185 581Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DA",
    horizAdvX: 278,
    d: "M139 727Q114 727 96 709T77 665Q77 640 95 622T139 603Q163 603 182 622T201 665Q201 690 183 708T139 727ZM139 767Q160 767 178 759T211 737T233 705T241 665Q241 644 233 626T211 593T179 571T139 563Q118 563 100 571T67 593T45 625T37 665Q37 686 45 704T67 737T99 759T139 767Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 278,
    d: "M-31 586Q-29 602 -24 621T-8 658T20 686T63 698Q82 698 103 691T144 675T182 659T217 652Q240 650 250 665T263 698H309Q307 682 302 663T286 626T258 598T215 586Q195 586 175 593T134 609T96 625T61 632Q38 634 28 619T15 586H-31Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 304H500V234H0V304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 304H1000V234H0V304Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 278,
    d: "M163 453H52L137 698H226L163 453Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 278,
    d: "M114 698H226L138 453H52L114 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 278,
    d: "M115 112H226L141 -133H52L115 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 556,
    d: "M396 453H286L370 698H460L396 453ZM208 453H96L182 698H270L208 453Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 556,
    d: "M349 698H460L375 453H286L349 698ZM159 698H270L185 453H96L159 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 556,
    d: "M349 112H460L375 -133H286L349 112ZM159 112H270L185 -133H96L159 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2020",
    horizAdvX: 556,
    d: "M234 453H67V523H234V698H322V523H489V453H322V0H234V453Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2021",
    horizAdvX: 556,
    d: "M322 162V0H234V162H67V232H234V466H67V536H234V698H322V536H489V466H322V232H489V162H322Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M76 349Q76 385 89 417T126 472T182 509T250 523Q286 523 318 510T374 473T411 417T425 349Q425 312 412 280T374 225T318 188T250 174Q214 174 182 187T127 224T90 280T76 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M777 112H889V0H777V112ZM444 112H556V0H444V112ZM111 112H223V0H111V112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2030",
    horizAdvX: 1000,
    d: "M153 380Q175 380 187 394T206 429T213 472T215 510Q215 527 215 549T209 592T191 626T153 640Q130 640 118 626T99 591T92 548T91 510Q91 495 92 473T99 430T117 395T153 380ZM847 -12Q804 -12 775 5T729 50T705 114T697 188Q697 228 703 264T726 328T772 372T847 388Q892 388 921 372T967 328T990 264T997 188Q997 150 990 114T965 50T919 5T847 -12ZM847 58Q869 58 881 72T900 107T907 150T909 188Q909 205 909 227T903 270T885 304T847 318Q824 318 812 304T793 269T786 226T785 188Q785 173 786 151T793 108T811 73T847 58ZM509 -12Q466 -12 437 5T391 50T367 114T359 188Q359 228 365 264T388 328T434 372T509 388Q554 388 583 372T629 328T652 264T659 188Q659 150 652 114T627 50T581 5T509 -12ZM509 58Q531 58 543 72T562 107T569 150T571 188Q571 205 571 227T565 270T547 304T509 318Q486 318 474 304T455 269T448 226T447 188Q447 173 448 151T455 108T473 73T509 58ZM511 720H583L150 -22H78L511 720ZM153 310Q110 310 81 327T35 372T11 436T3 510Q3 550 9 586T32 650T78 694T153 710Q198 710 227 694T273 650T296 586T303 510Q303 472 296 436T271 372T225 327T153 310Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 278,
    d: "M20 269L163 471H251L121 269L251 67H163L20 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 278,
    d: "M258 269L115 67H27L157 269L27 471H115L258 269Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 556,
    d: "M562 601Q538 614 502 621T438 628Q350 628 292 578T212 445H530L517 391H200Q195 349 200 307H499L487 253H212Q234 171 291 122T437 72Q467 72 501 78T562 97L568 10Q537 -2 500 -7T429 -12Q365 -12 311 6T214 58T143 141T101 253H6L19 307H94Q91 349 94 391H6L19 445H102Q115 505 144 554T216 637T313 691T429 710Q467 710 507 704T582 684L562 601Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 990,
    d: "M484 698H602L711 417L818 698H936V282H860V600H858L741 282H679L562 600H560V282H484V698ZM182 628H54V698H386V628H258V282H182V628Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE300",
    horizAdvX: 278,
    d: "M205 749H138L7 893H116L205 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE301",
    horizAdvX: 278,
    d: "M162 893H271L140 749H73L162 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE302",
    horizAdvX: 278,
    d: "M93 893H184L284 749H204L138 847L73 749H-6L93 893Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE303",
    horizAdvX: 278,
    d: "M185 749H94L-6 893H74L140 795L205 893H284L185 749Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE304",
    horizAdvX: 278,
    d: "M-31 754Q-29 770 -24 789T-8 826T20 854T63 866Q82 866 103 859T144 843T182 827T217 820Q240 818 250 833T263 866H309Q307 850 302 831T286 794T258 766T215 754Q195 754 175 761T134 777T96 793T61 800Q38 802 28 787T15 754H-31Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE305",
    horizAdvX: 278,
    d: "M174 856H268V756H174V856ZM10 856H104V756H10V856Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE308",
    horizAdvX: 278,
    d: "M139 893Q114 893 96 875T77 831Q77 806 95 788T139 769Q163 769 182 788T201 831Q201 856 183 874T139 893ZM139 933Q160 933 178 925T211 903T233 871T241 831Q241 810 233 792T211 759T179 737T139 729Q118 729 100 737T67 759T45 791T37 831Q37 852 45 870T67 903T99 925T139 933Z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0178",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFF",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xED",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "A",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "a",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "e",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "i",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "o",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "u",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE8",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xED",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2018",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0161",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: 87
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFrutiger55Roman);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/frutiger-55roman.02343fb5dcfc76f5b744e2f87e99cf6a.svg";